import register from '@kpsys/angularjs-register';

import recordDetailPathFilter from './record-detail-path.filter';
import charactersFilter from './characters';
import inlineFilter from './inline';
import jpDateFilter from './jp-date';
import locFilter from './loc';
import propFilter from './prop';
import strParamsFilter from './str-params';

/**
 * @ngdoc module
 * @name portaro.shared.filters
 * @module portaro.shared.filters
 */
export default register('portaro.shared.filters')
    .filter(recordDetailPathFilter.filterName, recordDetailPathFilter)
    .filter(charactersFilter.filterName, charactersFilter)
    .filter(inlineFilter.filterName, inlineFilter)
    .filter(jpDateFilter.filterName, jpDateFilter)
    .filter(locFilter.filterName, locFilter)
    .filter(propFilter.filterName, propFilter)
    .filter(strParamsFilter.filterName, strParamsFilter)
    .name();
